/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import DropdownArrowIcon from '@mui/icons-material/ArrowDropDown'

export function AffiliationsPopover({ occupationPaths }) {
  const [anchorEl, setAnchorEl] = useState(null)

  const onClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleRequestClose = () => {
    setAnchorEl(null)
  }

  return (
    <div style={{ display: 'inline-block' }}>
      {
    occupationPaths && occupationPaths.length > 1
    && (
    <div>
      <div onClick={(e) => onClick(e)}>
        Multiple
        <DropdownArrowIcon style={{ position: 'relative', top: '-1px', verticalAlign: 'middle' }} />
      </div>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleRequestClose}>
        {
          occupationPaths.map((path, i) => (<MenuItem key={i} style={{ fontSize: '14px' }}>{path}</MenuItem>))
        }
      </Menu>
    </div>
    )
  }
      { occupationPaths && occupationPaths.length === 1 && occupationPaths[0] }
    </div>
  )
}

export default AffiliationsPopover
